import { useContext } from 'react';
import { usePasskeyLogin } from 'LoginUI/hooks/usePasskeyLogin';
import { SmartLoginLandingPageContext } from '../v3/SmartLoginLandingPageContext';
import PasskeyLoginButton from './PasskeyLoginButton';
import { useLoginRequirementsData } from 'LoginUI/hooks/useLoginRequirementsData';
import { trackSmartLoginPasskeyLogin } from 'LoginUI/lib/tracker';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const PasskeyComponent = () => {
  const {
    isEmailSet,
    setError,
    availableLogins,
    loginRequirementPortalId,
    rememberLogin
  } = useContext(SmartLoginLandingPageContext);
  const {
    isPasskeyAvailable
  } = useLoginRequirementsData({
    availableLogins,
    loginRequirementPortalId
  });
  const {
    loginWithPasskey
  } = usePasskeyLogin({
    handleError: setError,
    requiredPortalId: loginRequirementPortalId,
    rememberLogin
  });
  if (isEmailSet && isPasskeyAvailable) {
    return /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "200",
      as: "div",
      children: /*#__PURE__*/_jsx(PasskeyLoginButton, {
        onClick: () => {
          trackSmartLoginPasskeyLogin('control');
          /* eslint-disable-next-line promise/catch-or-return, @typescript-eslint/no-floating-promises */
          loginWithPasskey();
        }
      })
    });
  }
  return null;
};
export default PasskeyComponent;